import type { DBTypes } from '@openphone/dexie-database/types'

export type AiJobDefinitionId = DBTypes.AiJobDefinition['id']
export type AiTriggerDefinitionId = DBTypes.AiTriggerDefinition['id']
export type AiTriggerDefinitionEntityId = DBTypes.AiTriggerDefinition['entityId']

export const isAiJobDefinitionId = (id: unknown): id is AiJobDefinitionId => {
  return typeof id === 'string' && /^AJD(.*)$/g.test(id)
}

export const isAiTriggerDefinitionId = (id: unknown): id is AiTriggerDefinitionId => {
  return typeof id === 'string' && /^ATD(.*)$/g.test(id)
}
